import EventModal from "../components/EventModal";
import CalendarHeader from "../components/CalendarHeader";
import { HiOutlineChevronDown } from "react-icons/hi";
import Month from "../components/Month";
import Sidebar from "../components/Sidebar";
import React, {useContext, useEffect, useState} from "react";
import {getMonth} from "../utils/util";
import GlobalContext from "../context/GlobalContext";
import logo from '../assets/logo.png'
import { Fragment } from 'react'
import { Disclosure, Menu, Transition } from '@headlessui/react'
import { BellIcon, MenuIcon, XIcon } from '@heroicons/react/outline'




const user = {
    name: 'Jordan',
    email: ""
    
  }
  const userNavigation = [
    // { name: 'Your Profile', href: '#' },
    // { name: 'Settings', href: '#' },
    { name: 'Sign out', href: '#' },
  ]
  
  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }

export default function Home(){

    const [currentMonth,setCurrentMonth]=useState(getMonth());
    const {monthIndex,showEventModal}= useContext(GlobalContext);
    useEffect(()=>{
        setCurrentMonth(getMonth(monthIndex))
    },[monthIndex])
    return(
        <>
      {/*
        This example requires updating your template:

        ```
        <html class="h-full bg-gray-100">
        <body class="h-full">
        ```
      */}
      <div className="min-h-full">
        <Disclosure as="nav" className="bg-gray-800">
          {({ open }) => (
            <>
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between h-16">
                  <div className="flex items-center">
                    <div className="flex-shrink-0">
                      <img
                        className="h-40 w-56 ml-24"
                        src={logo}
                        alt="Workflow"
                      />
                    </div>
                    
                  </div>
                  <div className="hidden md:block">
                    <div className="ml-4 flex items-center md:ml-6">
                      

                      {/* Profile dropdown */}
                      <Menu as="div" className="ml-3 relative">
                        <div className="text-gray-100 " style={{marginLeft:"-20px"}}>Welcome {user.name}</div>
                        <div>
                          <Menu.Button className="max-w-xs bg-gray-800 rounded-full flex items-center text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white">
                            <span className="sr-only">Open user menu</span>
                            <HiOutlineChevronDown className="h-4  bg-green-700" />
                          </Menu.Button>
                        </div>
                        <Transition
                          as={Fragment}
                          enter="transition ease-out duration-100"
                          enterFrom="transform opacity-0 scale-95"
                          enterTo="transform opacity-100 scale-100"
                          leave="transition ease-in duration-75"
                          leaveFrom="transform opacity-100 scale-100"
                          leaveTo="transform opacity-0 scale-95"
                        >
                          <Menu.Items className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                              <Menu.Item >
                                {({ active }) => (
                                  <a
                                    href="#"
                                    className={classNames(
                                      active ? 'bg-gray-100' : '',
                                      'block px-4 py-2 text-sm text-gray-700'
                                    )}
                                  >
                                    Sign Out
                                  </a>
                                )}
                              </Menu.Item>
                          </Menu.Items>
                        </Transition>
                      </Menu>
                    </div>
                  </div>
                  <div className="-mr-2 flex md:hidden">
                    {/* Mobile menu button */}
                    <Disclosure.Button className="bg-gray-800 inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white">
                      <span className="sr-only">Open main menu</span>
                      {open ? (
                        <XIcon className="block h-6 w-6" aria-hidden="true" />
                      ) : (
                        <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                      )}
                    </Disclosure.Button>
                  </div>
                </div>
              </div>

              <Disclosure.Panel className="md:hidden">
                
                <div className="pt-4 pb-3 border-t border-gray-700">
                  <div className="flex items-center px-5">
                    <div className="flex-shrink-0">
                      {/* <img className="h-10 w-10 rounded-full" src={user.imageUrl} alt="" /> */}
                    </div>
                    <div className="ml-3">
                      <div className="text-base font-medium leading-none text-white">Welcome {user.name}</div>
                      <div className="text-sm font-medium leading-none text-gray-400">{user.email}</div>
                    </div>
                  </div>
                  <div className="mt-3 px-2 space-y-1">
                    {userNavigation.map((item) => (
                      <Disclosure.Button
                        key={item.name}
                        as="a"
                        href={item.href}
                        className="block px-3 py-2 rounded-md text-base font-medium text-gray-400 hover:text-white hover:bg-gray-700"
                      >
                        {item.name}
                      </Disclosure.Button>
                    ))}
                  </div>
                </div>
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>

        <header className=" py-4 ">
          <div className="max-w-screen-2xl bg-slate-100 mx-auto py-6 px-4 sm:px-6 lg:px-8  shadow ">
            <h1 className="text-3xl font-bold text-gray-900">Calendar</h1>
          </div>
        </header>
        {/* <main className="flex">
        <Sidebar/> */}
        <main>
          <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
          
            
                {showEventModal && <EventModal/>}

                <div className=" sm:px-6 lg:px-8">
                    <div className="px-4  sm:px-0">
                        <div className="h-screen flex flex-col">
                            
                            <CalendarHeader/>
                            <div className="flex flex-1">
                                {/* <Sidebar/> */}
                                <Month month={currentMonth}/>
                            </div>
                        </div>
                    </div>
                </div>
            
            
        
            {/* <div className="px-4 py-6 sm:px-0">
              <div className="border-4 border-dashed border-gray-200 rounded-lg h-96" />
            </div> */}
            {/* /End replace */}
          </div>
        </main>
      </div>
    </>
  )
}